<script setup lang="ts">
import {VidalInteraction} from "@/drug-interaction/interfaces";
import {computed} from "vue";
import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from "@/core/components/ui/accordion";

const props = defineProps<{
    interaction: VidalInteraction;
}>();

const severityLabel = computed(() => props.interaction.severity.replace('LEVEL_', 'Niveau '));

const severityColor = computed(() => {
    const level = parseInt(props.interaction.severity.replace('LEVEL_', ''));
    if (level >= 3) return 'text-red-700';
    if (level === 2) return 'text-orange-600';
    return 'text-yellow-600';
});

const hasDetails = computed(() =>
    props.interaction.sub_type
    || props.interaction.content
);
</script>

<template>
  <div class="flex items-start justify-between gap-4 py-1 w-full">
    <div class="flex flex-col gap-1 flex-1 min-w-0">
      <div class="flex items-center justify-between gap-2">
        <span class="text-sm font-medium text-gray-800 truncate">{{ interaction.title }}</span>
        <span class="text-xs font-semibold shrink-0" :class="severityColor">{{ severityLabel }}</span>
      </div>

      <Accordion v-if="hasDetails" type="single" collapsible>
        <AccordionItem value="details" class="border-none">
          <AccordionTrigger class="py-0.5 text-xs text-gray-400 hover:text-gray-600 hover:no-underline font-normal">
            Voir les détails
          </AccordionTrigger>
          <AccordionContent>
            <div class="flex flex-col gap-2 pt-1">
              <p v-if="interaction.sub_type" class="text-xs italic text-gray-500">
                {{ interaction.sub_type }}
              </p>

              <div v-if="interaction.content" class="text-xs text-gray-700 space-y-3" v-html="interaction.content" />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </div>
</template>
